import {
  ErrorType,
  type ErrorViewOrderAction,
  LoadedType,
  type LoadedViewOrderAction,
  RequestType,
  type RequestViewOrderAction,
  UpsertType,
  type UpsertViewOrderAction,
} from 'common/actions/viewOrderQueries';

export type ViewOrderQueriesState = {
  [groupID: string]:
    | {
        error: string | null;
        loading: boolean;
        viewOrder: string[] | null;
      }
    | undefined;
};

type ViewOrderQueryAction =
  | RequestViewOrderAction
  | LoadedViewOrderAction
  | ErrorViewOrderAction
  | UpsertViewOrderAction;

export default function viewOrders(
  state: ViewOrderQueriesState = {},
  action: ViewOrderQueryAction,
): ViewOrderQueriesState {
  switch (action.type) {
    case RequestType: {
      const requestAction = action as RequestViewOrderAction;
      return {
        ...state,
        [requestAction.groupID]: {
          ...state[requestAction.groupID],
          error: null,
          loading: true,
          viewOrder: state[requestAction.groupID]?.viewOrder ?? null,
        },
      };
    }

    case LoadedType: {
      const loadedAction = action as LoadedViewOrderAction;
      return {
        ...state,
        [loadedAction.groupID]: {
          error: null,
          loading: false,
          viewOrder: loadedAction.viewOrder,
        },
      };
    }

    case ErrorType: {
      const errorAction = action as ErrorViewOrderAction;
      return {
        ...state,
        [errorAction.groupID]: {
          ...state[errorAction.groupID],
          error: errorAction.error,
          loading: false,
          viewOrder: state[errorAction.groupID]?.viewOrder ?? null,
        },
      };
    }

    case UpsertType: {
      const upsertAction = action as UpsertViewOrderAction;
      return {
        ...state,
        [upsertAction.groupID]: {
          error: null,
          loading: false,
          viewOrder: upsertAction.viewOrder,
        },
      };
    }

    default:
      return state;
  }
}
